import useApiPrivateClient from "../../hooks/useApiPrivateClient";
import { CreateFalloffData, UpdateFalloffData } from "./falloffs.requests";
import { Falloff } from "./falloffs.responses";

const useFalloffService = () => {
  const apiPrivateClient = useApiPrivateClient();

  const createFalloff = (falloffData: CreateFalloffData) => {
    return apiPrivateClient.post<Falloff>("/falloffs", falloffData);
  };

  const getFalloffs = () => {
    return apiPrivateClient.get<Falloff[]>("/falloffs");
  };

  const patchFalloff = (falloffId: number, updateData: UpdateFalloffData) => {
    return apiPrivateClient.patch<Falloff>(
      `/falloffs/${falloffId}`,
      updateData
    );
  };

  const deleteFalloff = (id: number) => {
    return apiPrivateClient.delete<void>(`/falloff/${id}`);
  };

  return {
    createFalloff,
    getFalloffs,
    patchFalloff,
    deleteFalloff,
  };
};

export default useFalloffService;
